import React from 'react'
import { Control, Controller, FieldValues } from 'react-hook-form'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Input, Text } from '@src/components/base'
import { validateFloatNumberInput } from '@src/utils/validators'
import { HealthDataMetricBiomarker } from '@src/types'

export interface BiomarkerFormInputProps {
  control: Control<FieldValues, any>
  label: string
  kind: HealthDataMetricBiomarker
  unit: string | undefined
}

export const BiomarkerFormInput = (props: BiomarkerFormInputProps) => {
  const styles = useStyleSheet(themedStyle)
  const { control, label, kind, unit } = props

  return (
    <View key={`${kind}-view`} style={styles.inputGroup}>
      <Text key={`${kind}-label`} type="regular" lineSpacing="tight" style={styles.input}>
        {label}
      </Text>
      <Controller
        control={control}
        key={kind}
        name={kind}
        render={({ field }) => (
          <Input
            {...field}
            key={kind}
            accessoryRight={
              <Text numberOfLines={1} type="regular" style={styles.unit}>
                {unit}
              </Text>
            }
            style={styles.input}
            keyboardType="decimal-pad"
            value={field.value}
            onChangeText={(text) => {
              const value = validateFloatNumberInput(text)
              field.onChange(value)
            }}
          />
        )}
      />
    </View>
  )
}

const themedStyle = StyleService.create({
  inputGroup: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    marginTop: 12,
    flex: 1,
  },
  unit: {
    maxWidth: 80,
  },
})
